import { TextSection } from "components/TextSection";
import { ReactComponent as Logo } from "assets/svg/logo.svg";
import { ReactComponent as BodySVG } from "assets/content/results/body.svg";
import { ReactComponent as EighteenSVG } from "assets/content/results/18.svg";
import { ReactComponent as ImmuneSystemSVG } from "assets/content/results/immune.svg";
import titleImg from "assets/content/pro-hero-subscribe.png";
import one from "../Home/assets/img/1.png";
import two from "../Home/assets/img/2.png";
import three from "../Home/assets/img/3.png";
import four from "../Home/assets/img/4.png";
import five from "../Home/assets/img/5.png";
import six from "../Home/assets/img/6.png";
import seven from "../Home/assets/img/7.png";
import grazia from "../Home/assets/img/grazia.png";
import elle from "../Home/assets/img/elle.png";
import peopletalk from "../Home/assets/img/peopletalk.png";
import cosmo from "../Home/assets/img/cosmo.png";
import instyle from "../Home/assets/img/instyle.png";
import bazaar from "../Home/assets/img/bazaar.png";
import basketballImg from "assets/content/basketball.webp";

import { ReactComponent as ForkAndSVG } from "assets/content/results/fork_spoon.svg";
import { ReactComponent as FlashSVG } from "assets/content/results/flash.svg";
import { ReactComponent as BackSideSVG } from "assets/content/results/back_side.svg";
import { ReactComponent as StandSVG } from "assets/content/results/stand.svg";
import { ReactComponent as StomachSVG } from "assets/content/results/stomach.svg";
import { ReactComponent as InfographySVG } from "assets/content/pro/infography.svg";
import { ReactComponent as InfographyMobileSVG } from "assets/content/pro/infography-mobile.svg";

import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Footer } from "components/Footer";

// Hook for scroll animations
const useScrollAnimation = (delay = 0) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return { elementRef, isVisible };
};

// Animated wrapper component
const AnimatedSection: React.FC<{
  children: React.ReactNode;
  delay?: number;
  animationType?: 'fadeUp' | 'fadeIn' | 'slideLeft' | 'slideRight' | 'scale';
  className?: string;
}> = ({ children, delay = 0, animationType = 'fadeUp', className = '' }) => {
  const { elementRef, isVisible } = useScrollAnimation(delay);

  const getAnimationStyle = () => {
    const baseStyle = {
      transition: 'all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)',
    };

    switch (animationType) {
      case 'fadeUp':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0px)' : 'translateY(50px)',
        };
      case 'fadeIn':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
        };
      case 'slideLeft':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateX(0px)' : 'translateX(-50px)',
        };
      case 'slideRight':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateX(0px)' : 'translateX(50px)',
        };
      case 'scale':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(0.9)',
        };
      default:
        return baseStyle;
    }
  };

  return (
    <div ref={elementRef} className={className} style={getAnimationStyle()}>
      {children}
    </div>
  );
};

const intro = (
  <>
    <div className="prose mx-auto hidden sm:block md:block lg:block">
      <div className="flex gap-5 justify-center flex-wrap mb-5">
        <div className="w-44 m-0 shrink-0 text-center">
          <Link to="/bodyflex">
            <img className="w-44 h-44 m-0" src={one} alt="title" />
          </Link>
          <Link to="/bodyflex#buyRef" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
            Шпак Метод Бодифлекс
          </Link>
          <p className="text-xs mt-1">Уменьшает отеки и объемы, сжигает жиры, выводит лишнюю жидкость.</p>
        </div>
        <div className="w-44 m-0 shrink-0 text-center">
          <Link to="/oxycise">
            <img className="w-44 h-44 m-0" src={two} alt="title" />
          </Link>
          <Link to="/oxycise" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
            Шпак Метод Оксисайз New
          </Link>
          <p className="text-xs mt-1">Сжигает жир, снижает аппетит, интимное здоровье.</p>
        </div>
        <div className="w-44 m-0 shrink-0 text-center">
          <Link to="/charger">
            <img className="w-44 h-44 m-0" src={three} alt="title" />
          </Link>
          <Link to="/charger" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
            Шпак Метод Зарядка
          </Link>
          <p className="text-xs mt-1">Ментальный фитнес за 10 минут. База для новичков.</p>
        </div>
      </div>
      <div className="flex gap-5 justify-center flex-wrap md:flex-nowrap lg:flex-nowrap">
        <div className="w-44 m-0 shrink-0 text-center">
          <Link to="/pro">
            <img className="w-44 h-44 m-0" src={four} alt="title" />
          </Link>
          <Link to="/pro#buy" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
            ШпакМетод MIX
          </Link>
          <p className="text-xs mt-1">Сжигает жир в 9 раз быстрее! Комплексная тренировка.</p>
        </div>
        <div className="w-44 m-0 shrink-0 text-center">
          <Link to="/vip">
            <img className="w-44 h-44 m-0" src={five} alt="title" />
          </Link>
          <Link to="/vip" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
            VIP «Дыши и худей»
          </Link>
          <p className="text-xs mt-1">8 минут в день для идеального тела. Быстрый результат.</p>
        </div>

        <img className="w-44 h-44 m-0 opacity-20" src={six} alt="title" />
        <img className="w-44 h-44 m-0 opacity-20" src={seven} alt="title" />
      </div>
    </div>

    <div className="prose flex flex-col mx-auto sm:hidden md:hidden lg:hidden gap-10">
      <div className="w-full m-0 shrink-0 text-center">
        <Link to="/bodyflex">
          <img className="w-full h-full m-0" src={one} alt="title" />
        </Link>
        <Link to="/bodyflex#buyRef" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
          Шпак Метод Бодифлекс
        </Link>
        <p className="text-xs mt-1">Уменьшает отеки и объемы, сжигает жиры, выводит лишнюю жидкость.</p>
      </div>

      <div className="w-full m-0 shrink-0 text-center">
        <Link to="/oxycise">
          <img className="w-full h-full m-0" src={two} alt="title" />
        </Link>
        <Link to="/oxycise" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
          Шпак Метод Оксисайз New
        </Link>
        <p className="text-xs mt-1">Сжигает жир, снижает аппетит, интимное здоровье.</p>
      </div>

      <div className="w-full m-0 shrink-0 text-center">
        <Link to="/charger">
          <img className="w-full h-full m-0" src={three} alt="title" />
        </Link>
        <Link to="/charger" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
          Шпак Метод Зарядка
        </Link>
        <p className="text-xs mt-1">Ментальный фитнес за 10 минут. База для новичков.</p>
      </div>

      <div className="w-full m-0 shrink-0 text-center">
        <Link to="/pro">
          <img className="w-full h-full m-0" src={four} alt="title" />
        </Link>
        <Link to="/pro#buy" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
          ШпакМетод MIX
        </Link>
        <p className="text-xs mt-1">Сжигает жир в 9 раз быстрее! Комплексная тренировка.</p>
      </div>

      <div className="w-full m-0 shrink-0 text-center">
        <Link to="/vip">
          <img className="w-full h-full m-0" src={five} alt="VIP" />
        </Link>
        <Link to="/vip" className="block mt-2 text-sm font-bold text-rose-500 hover:underline">
          VIP «Дыши и худей»
        </Link>
        <p className="text-xs mt-1">8 минут в день для идеального тела. Быстрый результат.</p>
      </div>
      <img className="w-full h-full m-0  opacity-20" src={six} alt="title" />
      <img className="w-full h-full m-0  opacity-20" src={seven} alt="title" />
    </div>

    <p>
      <strong>Шпак Метод</strong> — запатентованный метод дыхательных тренировок, основанный на техниках диафрагмального дыхания, современных упражнениях и концепции долголетия, well-being и практиках восстановления внутреннего ресурса. Шпак Метод направлен на <strong>быстрое жиросжигание и укрепление иммунитета — без диет и ограничений, всего за 10–20 минут в день, не выходя из дома.</strong>
    </p>

    <p>
      Шпак Метод – это <strong>ментальный фитнес</strong>, помогающий повысить уровень энергии, развить осознанность и улучшить качество жизни и тела.
    </p>

    <p><strong>Как это работает?</strong></p>
    <p>
      Жир (или липиды) — это топливо нашего тела. Когда мы дышим определённым образом, запускается процесс окисления этого топлива. Липиды расщепляются, и организм начинает избавляться от жировых отложений — особенно в тех местах, где их больше всего. Окисление жирных кислот возможно только в аэробных условиях, и именно дыхание играет ключевую роль в превращении жира в энергию.
    </p>

    <p><strong>Что вы получите</strong></p>
    <ul className="list-disc ml-6">
      <li>Снижение веса без диет</li>
      <li>Уменьшение объёмов и живота</li>
      <li>Улучшение состояния кожи и лица</li>
      <li>Спокойную нервную систему</li>
      <li>Повышение энергии и настроения</li>
      <li>Контакт с телом и внутренний баланс</li>
    </ul>

    <p className="italic">
      Это не просто тренировка. Это способ восстановить себя.
    </p>
  </>
);

const resultIconStyle =
  "text-white text-sm flex flex-col items-center gap-4 w-52 mb-10";
const textSpanStyle = "flex justify-center text-center items-center text-sm";

const resultsContent = (
  <div className="bg-rose-500 prose min-w-full p-4 gap-x-8 text-center">
    <h1 className="text-white font-serif mt-20">Результаты:</h1>
    <div className="flex flex-wrap justify-around items-center mt-10">
      <div className={resultIconStyle}>
        <BodySVG />
        <div>
          <span className={textSpanStyle}>
            Сжигание жира, уменьшение висцирального жира
          </span>
        </div>
      </div>
      <div className={resultIconStyle}>
        <BackSideSVG />
        <div>
          <span className={textSpanStyle}>
            Избавление от отечности и целлюлита
          </span>
        </div>
      </div>
      <div className={resultIconStyle}>
        <ImmuneSystemSVG />
        <div>
          <span className={textSpanStyle}>
            Улучшение работы имунной системы
          </span>
        </div>
      </div>
      <div className={resultIconStyle}>
        <StomachSVG />
        <div>
          <span className={textSpanStyle}>
            Улучшение работы кишечника. сокращение размеров желудка
          </span>
        </div>
      </div>
    </div>
    <div className="flex flex-wrap justify-around items-center">
      <div className={resultIconStyle}>
        <StandSVG />
        <div>
          <span className={textSpanStyle}>
            Стимулирование лактации и активация работы яичников
          </span>
        </div>
      </div>
      <div className={resultIconStyle}>
        <ForkAndSVG />
        <div>
          <span className={textSpanStyle}>
            Укращение метаболизма и снижение аппетита
          </span>
        </div>
      </div>
      <div className={resultIconStyle}>
        <FlashSVG />
        <div>
          <span className={textSpanStyle}>
            Устранение синдрома хронической усталости
          </span>
        </div>
      </div>
      <div className={resultIconStyle}>
        <EighteenSVG />
        <div>
          <span className={textSpanStyle}>
            Повышение сексуального желания и половой активности
          </span>
        </div>
      </div>
    </div>
  </div>
);

const aboutMe = (
  <div className="">
    <div>
      <h2 className="text-center font-bold text-2xl mb-6">Об авторе Шпак Метода</h2>
      <p>
        <strong>
          Меня зовут <span className="text-rose-500">Алина Шпак</span>. Я тренер-преподаватель, мой профиль — дыхательные жиросжигающие тренировки.
        </strong>
        {' '}Автор книги-бестселлера «Ешь, пей, дыши, худей!», тренер года по версии Cosmopolitan и создатель запатентованного метода, который помогает женщинам по всему миру возвращать стройность, лёгкость и внутреннюю силу — без диет, без давления, без чувства вины.
      </p>

      <h3 className="font-bold text-lg mt-6 mb-3">Как всё началось</h3>
      <p>
        15 лет назад я искала не очередную диету, а способ жить в теле, которое не хочется мучить. Я перепробовала всё: спорт, голодовки, «волшебные схемы» — и поняла, что нужно искать не внешнее решение, а внутреннюю настройку.
      </p>
      <p>
        Я начала изучать физиологию, дыхательные методики, практики восстановления, биомеханику и психосоматику. Постепенно я собрала работающую систему, которая стала моим авторским методом — Шпак Методом.
      </p>

      <h3 className="font-bold text-lg mt-6 mb-3">Почему мне можно доверять</h3>
      <ul className="list-disc ml-6">
        <li>У меня высшее тренерское образование</li>
        <li>Мой авторский подход запатентован как способ оздоровления организма и похудения</li>
        <li>Я училась в Гарварде, Йельском университете и KAIST (Южная Корея) — где изучала научные подходы к ощущению благополучия, стресс-менеджменту, улучшению качества жизни и работе с психосоматикой</li>
      </ul>
    </div>
  </div>
);

const whoIHelp = (
  <div className="">
    <div>
      <h2 className="text-center font-bold text-2xl mb-6">Кому я помогаю</h2>
      <p>Более 10 лет я работаю с:</p>
      <ul className="list-disc ml-6">
        <li>женщинами после родов, гормональных сбоев и стресса,</li>
        <li>мужчинами, которым нужно прийти в форму, восстановление и фокус,</li>
        <li>известными артистами и олимпийскими чемпионами,</li>
        <li>людьми с ограниченными возможностями.</li>
      </ul>
      <p>У каждого — своя история. Но цель одна: вернуться в тело, которое нравится и в котором комфортно жить.</p>
      <p className="text-center mt-6 p-4 bg-rose-50 rounded-lg border-l-4 border-rose-500">
        📌 <strong>Шпак Метод</strong> — это ментальный фитнес с жиросжигающим эффектом. Это способ жить в теле, которое не нужно переделывать. Его нужно просто включить.
      </p>
      <p className="text-center mt-4 font-semibold text-rose-600">
        Начните дышать и худеть!
      </p>
    </div>
  </div>
);

const articles = (
  <>
    <h1 className="text-center">Статьи</h1>
    <div className="flex flex-col md:flex-row justify-between content-center items-center">
      <a href="https://www.thesymbol.ru/beauty/health/kak-pohudet-bez-trenirovok-c-pomoshchyu-dyhatelnyh-praktik/">
        <img className="w-44 h-full" src={bazaar} alt="BAZAAR" />
      </a>
      <a href="https://graziamagazine.ru/lifestyle/dyshite-ne-dyshite-6-mifov-o-bodiflekse/amp/">
        <img className="w-40 h-full" src={grazia} alt="GRAZIA" />
      </a>
      <a
        href="https://www.elle.ru/krasota/esh-pei-dyshi-khudei-kak-s-pomoshyu-dykhatelnoi-praktiki-mozhno-sbrosit-ves/

"
      >
        <img className="w-32 h-full" src={elle} alt="Elle" />
      </a>
    </div>
    <div className="flex flex-col md:flex-row justify-between content-center items-center">
      <a href="https://peopletalk.ru/article/chto-delat-esli-vse-ploho-eksklyuzivnye-sovety-ot-korolevy-bodifleksa-i-blogera-aliny-shpak/">
        <img className="w-52 h-full" src={peopletalk} alt="PEOPLETALK" />
      </a>
      <a
        href="https://www.thevoicemag.ru/health/sport/dyshu-i-hudeyu-3-tehniki-bodifleksa-chtoby-szhigat-zhir-bystree/
"
      >
        <img className="w-40 h-full" src={cosmo} alt="COSMO.RU" />
      </a>
      <img className="w-40 h-full" src={instyle} alt="InStyle" />
    </div>
  </>
);

const Header = () => {
  return (
    <div className="absolute w-full">
      <nav className="bg-header flex pl-9 w-full items-center justify-center top-0 z-10">
        <div className="h-16 flex justify-center items-center flex-none">
          <Logo className="cursor-pointer" />
        </div>
      </nav>
    </div>
  );
};
const Insertion = ({ introRef }: any) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    // Предзагружаем фоновые изображения
    const img = new Image();

    img.onload = () => {
      setImageLoading(false);
      setTimeout(() => setIsLoaded(true), 100);
    };

    img.src = titleImg;
  }, []);

  return (
    <>
      {imageLoading && (
        <div className="fixed inset-0 bg-white z-50 flex items-center justify-center overflow-hidden">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-red-500 mx-auto mb-4"></div>
            <p className="text-gray-600 text-lg">Загрузка...</p>
          </div>
        </div>
      )}
      <div className="bg-red-100 relative lg:hidden"></div>
      <div
        className="flex mx-auto bg-proHeroBg bg-no-repeat bg-cover w-auto h-screen bg-rose-200 lg:visible content-center lg:justify-start items-center"
        style={{
          backgroundPosition: '70% top',
          opacity: isLoaded ? 1 : 0,
          transform: isLoaded ? 'scale(1)' : 'scale(1.1)',
          transition: 'all 1.2s cubic-bezier(0.25, 0.8, 0.25, 1)'
        }}
      >
        <div className="flex lg:content-center items-center sm:justify-end md:justify-center lg:justify-center sm:content-end h-full p-8">
          <a href="https://t.me/alishka_shpak">
            <img
              className="lg:ml-6 shrink-0 lg:max-w-xl lg:self-center mt-32 lg:mt-0 md:mb-2 md:self-end self-center md:w-3/4"
              src={titleImg}
              alt=""
              style={{
                opacity: isLoaded ? 1 : 0,
                transform: isLoaded ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
                transition: 'all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)',
                transitionDelay: '0.3s'
              }}
            />
          </a>
        </div>
      </div>
      <div ref={introRef} />
    </>
  );
};

const About = () => {
  return (
    <div className="flex md:flex-row flex-col">
      <div className="md:w-1/2 bg-basketballBg bg-no-repeat bg-center bg-cover">
        {" "}
        <a href="https://t.me/alishka_shpak">
          <img
            className="md:hidden"
            src={basketballImg}
            alt="Обо мне"
          />
        </a>
      </div>
      <div className="md:w-1/2">
        <article className="prose mx-auto text-base font-serif container p-4">
          {aboutMe}
        </article>
      </div>
    </div>
  );
};

export const Home = () => {
  const topRef = useRef<HTMLDivElement>(null);
  const introRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={topRef} className="overflow-x-hidden">
      <Header />
      <Insertion introRef={introRef} />

      <AnimatedSection animationType="fadeUp">
        <TextSection content={intro} />
      </AnimatedSection>

      <AnimatedSection animationType="scale" delay={200}>
        {resultsContent}
      </AnimatedSection>

      <AnimatedSection animationType="slideLeft">
        <About />
      </AnimatedSection>

      <AnimatedSection animationType="slideRight">
        <div className="flex md:flex-row flex-col">
          <div className="md:w-1/2 bg-proAboutMeBg bg-no-repeat bg-top bg-cover">
            {" "}
            <a href="https://t.me/alishka_shpak">
              <img
                className="md:hidden"
                src={require("assets/content/about-me.jpg")}
                alt="Кому я помогаю"
              />
            </a>
          </div>
          <div className="md:w-1/2">
            <article className="prose mx-auto text-base font-serif container p-4">
              {whoIHelp}
            </article>
          </div>
        </div>
      </AnimatedSection>

      <AnimatedSection animationType="fadeUp" delay={100}>
        <TextSection content={articles} />
      </AnimatedSection>

      <div className="bg-separator h-16 bg-repeat-x" />

      <AnimatedSection animationType="fadeIn">
        <Footer />
      </AnimatedSection>
    </div>
  );
};
